(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('velestoria-product-total')) {
  class VelestoriaProductTotal extends HTMLElement {
    static quotes = new Map();
    #events;
    #request;
    #timer;
    #refresh;
    #debounce;
    #key;
    #root;
    #state;
    #quantityUnsubscribe;
    connectedCallback() {
      this.#events = new AbortController();
      this.#root = this.closest('product-info') || this.closest('.shopify-section');
      if (!this.#root) return;
      const options = {signal: this.#events.signal};
      const quantityChanged = event => {
        if (event.target.matches('input[name="quantity"], input[name="selling_plan"]')) this.#sync();
      };
      this.#root.addEventListener('input', quantityChanged, options);
      this.#root.addEventListener('change', quantityChanged, options);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.#quantityUnsubscribe = subscribe(PUB_SUB_EVENTS.quantityUpdate, () => queueMicrotask(() => { if (this.isConnected) this.#sync(); }));
      }
      window.addEventListener('focus', () => this.#sync(), options);
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) { this.#tick(); this.#sync(); }
      }, options);
      this.#refresh = setInterval(() => {
        const bounds = this.getBoundingClientRect();
        if (!document.hidden && bounds.bottom > 0 && bounds.top < window.innerHeight) this.#sync();
      }, 60000);
      this.#timer = setInterval(() => this.#tick(), 1000);
      this.#tick();
      this.#sync();
    }
    disconnectedCallback() {
      this.#events?.abort();
      this.#quantityUnsubscribe?.();
      this.#request?.abort();
      clearTimeout(this.#debounce);
      clearInterval(this.#timer);
      clearInterval(this.#refresh);
    }
    #money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: this.dataset.currency,
        currencyDisplay: this.dataset.currencyCode === 'true' ? 'code' : 'symbol'
      }).format(cents / 100);
    }
    #text(key, values = {}) {
      let text = this.dataset[key] || '';
      for (const [name, value] of Object.entries(values)) text = text.replaceAll('[' + name + ']', String(value));
      return text;
    }
    #render(state) {
      this.#state = state;
      const total = state.amount ?? state.base;
      const comparison = state.quantity > 1 ? state.base : Math.max(state.base, Number(this.dataset.compare));
      const discounted = comparison > total;
      const price = this.querySelector('.price');
      if (!price) return;
      price.classList.toggle('price--on-sale', discounted);
      price.classList.remove('price--no-compare');
      for (const node of price.querySelectorAll('.price__regular .price-item--regular, .price__sale .price-item--sale')) node.textContent = this.#money(total);
      const oldPrice = price.querySelector('.price__compare-price');
      if (oldPrice) {
        oldPrice.hidden = !discounted;
        const value = oldPrice.querySelector('s');
        if (value) value.textContent = this.#money(comparison);
      }
      const label = this.querySelector('[data-total-label]');
      label.hidden = state.quantity <= 1;
      label.textContent = this.#text('totalLabel', {quantity: state.quantity, unit: this.#money(Number(this.dataset.unit))});
      const saving = this.querySelector('[data-total-saving]');
      saving.hidden = !discounted || this.dataset.showDiscount !== 'true' || state.status === 'pending' && state.amount == null;
      const percent = comparison > 0 ? Math.round((comparison - total) * 100 / comparison) : 0;
      saving.textContent = this.#text('savingLabel', {percent, amount: this.#money(comparison - total)});
      const note = this.querySelector('[data-total-note]');
      note.hidden = state.quantity <= 1 && state.status !== 'unavailable';
      note.textContent = state.status === 'pending' ? this.#text('loadingLabel') : state.status === 'unavailable' ? this.#text('fallbackLabel') : this.#text('cartLabel');
      price.setAttribute('aria-busy', String(state.status === 'pending'));
      this.dataset.quoteState = state.status;
      this.dataset.total = String(total);
    }
    #sync() {
      const input = this.#root.querySelector('input[name="quantity"]');
      const quantity = Number(input?.value || 1);
      if (!Number.isSafeInteger(quantity) || quantity < 1) return;
      const unit = Number(this.dataset.unit);
      const base = unit * quantity;
      const id = this.dataset.variant;
      const key = JSON.stringify([this.dataset.country, this.dataset.currency, id, quantity, unit]);
      if (key === this.#key && this.#state?.status === 'pending') return;
      const previous = this.#key === key ? this.#state : null;
      this.#key = key;
      this.#request?.abort();
      clearTimeout(this.#debounce);
      const cached = VelestoriaProductTotal.quotes.get(key);
      if (cached && cached.expires > Date.now()) { this.#render({...cached, quantity, base}); return; }
      const state = {quantity, base, status: 'pending'};
      if (previous?.status === 'ready') state.amount = previous.amount;
      this.#render(state);
      this.#request = new AbortController();
      const controller = this.#request;
      this.#debounce = setTimeout(async () => {
        try {
          const amount = await this.#quote(id, quantity, base, controller.signal);
          if (!this.isConnected || this.#key !== key || controller.signal.aborted) return;
          const result = {amount, status: 'ready', expires: Date.now() + 60000};
          if (VelestoriaProductTotal.quotes.size >= 100) VelestoriaProductTotal.quotes.delete(VelestoriaProductTotal.quotes.keys().next().value);
          VelestoriaProductTotal.quotes.set(key, result);
          this.#render({...result, quantity, base});
        } catch {
          if (!this.isConnected || this.#key !== key || controller.signal.aborted) return;
          const result = {status: 'unavailable', expires: Date.now() + 15000};
          VelestoriaProductTotal.quotes.set(key, result);
          this.#render({...result, quantity, base});
        }
      }, 180);
    }
    async #quote(id, quantity, base, signal) {
      const query = `mutation ProductPriceQuote($input: CartInput!) {
  cartCreate(input: $input) {
    cart {
      totalQuantity
      lines(first: 10) { nodes {
        quantity
        merchandise { ... on ProductVariant { id } }
        cost { subtotalAmount { amount currencyCode } }
        discountAllocations(lineLevelOnly: false) { targetType discountedAmount { amount currencyCode } }
      } }
    }
    userErrors { field message }
    warnings { code message }
  }
}`;
      const merchandiseId = 'gid://shopify/ProductVariant/' + id;
      const response = await fetch('/api/2026-10/graphql.json', {
        method: 'POST', credentials: 'omit', headers: {'Content-Type': 'application/json'},
        signal: AbortSignal.any([signal, AbortSignal.timeout(6000)]),
        body: JSON.stringify({query, variables: {input: {lines: [{merchandiseId, quantity}], buyerIdentity: {countryCode: this.dataset.country}}}})
      });
      if (!response.ok) throw Error('Quote unavailable');
      const result = await response.json();
      const payload = result.data?.cartCreate;
      const cart = payload?.cart;
      if (result.errors?.length || payload?.userErrors?.length || payload?.warnings?.length || cart?.totalQuantity !== quantity) throw Error('Incomplete quote');
      const nodes = cart.lines.nodes;
      if (nodes.length !== 1 || nodes[0].merchandise.id !== merchandiseId || nodes[0].quantity !== quantity) throw Error('Selection mismatch');
      const cents = money => {
        if (money.currencyCode !== this.dataset.currency) throw Error('Currency mismatch');
        const value = Math.round(Number(money.amount) * 100);
        if (!Number.isSafeInteger(value) || value < 0) throw Error('Invalid amount');
        return value;
      };
      const subtotal = cents(nodes[0].cost.subtotalAmount);
      if (subtotal !== base) throw Error('Unit price mismatch');
      let discount = 0;
      for (const allocation of nodes[0].discountAllocations) {
        if (allocation.targetType === 'LINE_ITEM') discount += cents(allocation.discountedAmount);
      }
      if (discount > subtotal) throw Error('Invalid discount');
      return subtotal - discount;
    }
    #tick() {
      const countdown = this.querySelector('[data-total-countdown]');
      if (!countdown) return;
      try {
        let remaining;
        if (this.dataset.timerMode === 'daily') {
          const parts = new Intl.DateTimeFormat('en-GB', {timeZone: this.dataset.timezone, hourCycle: 'h23', hour: '2-digit', minute: '2-digit', second: '2-digit'}).formatToParts(new Date());
          const read = type => Number(parts.find(part => part.type === type)?.value);
          remaining = 86400 - read('hour') * 3600 - read('minute') * 60 - read('second');
        } else {
          const deadline = this.dataset.deadline || '';
          if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(deadline)) throw Error('Invalid deadline');
          remaining = Math.ceil((Date.parse(deadline) - Date.now()) / 1000);
        }
        if (!Number.isFinite(remaining) || remaining <= 0) { countdown.hidden = true; return; }
        const hours = Math.floor(remaining / 3600);
        const minutes = Math.floor(remaining % 3600 / 60);
        const seconds = remaining % 60;
        countdown.querySelector('time').textContent = [hours, minutes, seconds].map(value => String(value).padStart(2, '0')).join(':');
        countdown.hidden = false;
      } catch { countdown.hidden = true; }
    }
  }
  customElements.define('velestoria-product-total', VelestoriaProductTotal);
}
  } catch(e) { console.error(e); }
})();

})();
